import Workflow from '../../pages/Workflow'
import Welcome from '../../panels/Welcome'
import UserInfo from '../../panels/UserInfo'
import AddressInfo from '../../panels/AddressInfo'
import ServiceChoices from '../../panels/ServiceChoices'
import ServiceNotes from '../../panels/ServiceNotes'

const workflowSteps = 5

export const newUserRoute = {
  path: '/newUser',
  name: 'newUser',
  component: Workflow,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'welcome',
      component: Welcome,
      alias: '',
      meta: {
        requiresAuth: true,
        nextRoute: '/newUser/userInfo',
        workflowSteps,
        currentStep: 1,
        navButton: 'Continue',
        inputValid: true
      }
    },
    {
      path: 'userInfo',
      component: UserInfo,
      meta: {
        requiresAuth: true,
        nextRoute: '/newUser/addressInfo',
        workflowSteps,
        currentStep: 2,
        navButton: 'Looks Good!',
        inputValid: 'userInputValid'
      }
    },
    {
      path: 'addressInfo',
      component: AddressInfo,
      meta: {
        requiresAuth: true,
        nextRoute: 'service',
        workflowSteps,
        currentStep: 3,
        navButton: 'Show Me My Choices',
        inputValid: 'addressInputValid'
      }
    },
    {
      path: 'service',
      component: ServiceChoices,
      meta: {
        requiresAuth: true,
        nextRoute: 'notes',
        workflowSteps,
        currentStep: 4,
        navButton: 'On to Notes',
        inputValid: true
      }
    },
    {
      path: 'notes',
      component: ServiceNotes,
      meta: {
        requiresAuth: true,
        nextRoute: '/account?submit=true',
        workflowSteps,
        currentStep: 5,
        navButton: 'Submit',
        inputValid: true,
        beforeRouteLeave: workflowExit
      }
    }
  ]
}

function workflowExit (to, from, next, context) {
  if (to.name === 'account' && to.query.submit) {
    context.setLoading()

    // If we're going to the account page from here, then we're saving an updated profile
    context.$store.commit('updateNewUser', false)
    context.$store.commit('updateValidationRequired', false)

    context.$store.dispatch('userAccountUpdate')
      .then((result) => {
        console.log('Successfully updated account data: %j', result)
        next()
      })
      .catch((reason) => {
        console.log('Updating account data failed: %j', reason)
        // TODO how to display the error message
        context.clearLoading()
        next(false)
      })

    context.$store.dispatch('userAddressUpdate')
      .then((result) => {
        console.log('Successfully updated address data: %j', result)
        next()
      })
      .catch((reason) => {
        console.log('Updating address data failed: %j', reason)
        // TODO how to display the error message
        context.clearLoading()
        next(false)
      })

    context.$store.dispatch('userServiceUpdate')
      .then((result) => {
        console.log('Successfully updated service data: %j', result)
        next()
      })
      .catch((reason) => {
        console.log('Updating service data failed: %j', reason)
        // TODO how to display the error message
        context.clearLoading()
        next(false)
      })

    context.$store.dispatch('messageSend')
      .then((result) => {
        console.log('Successfully sent the service submission message')
        next()
      })
      .catch((reason) => {
        console.log('Sending service submission message failed: %j', reason)
        // TODO how to display the error message
        context.clearLoading()
        next(false)
      })
  } else {
    next()
  }
}

export default newUserRoute



// WEBPACK FOOTER //
// ./src/router/workflows/newUser.js